import ReportDetailsHeader from 'Components/ReportDetailsHeader'
import React from 'react'
import { Card, CardHeader, Row, Col, TabContent, TabPane } from 'reactstrap'
import OtherDetails from './partials/OtherDetails'
import { useEditReport } from 'VesselReportingInfo/EditCompletedReports/EditReportProvider'

const AryaAddInformation = () => {
    const { activeAddAryaTab } = useEditReport();
    return (
        <Card className='p-0 mb-0 border-0'>
            <CardHeader className='p-2'>
                <div className="text-center">
                    <Row>
                        <Col>
                            <h4 className="page_title pos-start mb-0">Additional Information</h4>
                            <p className="card-title-desc pos-start">All readings since last report</p>
                        </Col>
                        <Col>
                            <ReportDetailsHeader />
                        </Col>
                    </Row>
                </div>
            </CardHeader>
            <div id="basic-pills-wizard" className="twitter-bs-wizard">
                <TabContent activeTab={activeAddAryaTab} className="tabHeight">
                    <TabPane tabId={1}>
                        <OtherDetails />
                    </TabPane>
                </TabContent>
            </div>
        </Card>
    )
}

export default AryaAddInformation